import React from 'react';

const ITServicesIndustries = () => {
  return (
    <main style={{ padding: 40, minHeight: '60vh' }}>
      <h1>AILYT IT Services — Industries</h1>
      <p>Industries we serve: Insurance, Education, Startups, SMEs.</p>
    </main>
  );
};

export default ITServicesIndustries;
